module.exports = __webpack_public_path__ + "img/avatar.5737899f.jpg";